<template>
    <div>
        <Toolbar>
            <BackButton v-if="$page.props.previous_url"/>

            <template v-slot:right>
                <ToolbarLink :href="$route('user.requests.index')">
                    <i class="fas fa-envelope-open-text"/>
                    {{ __('user.my_requests') }}
                </ToolbarLink>
            </template>
        </Toolbar>
        <Card>
            <h3 class="mb-5">{{ __('agency.assign') }}</h3>

            <form>
                <div class="pt-3">
                    <div class="d-flex align-items-center w-100 font-size-h4">
                        <div class="d-flex">
                            <div class="symbol symbol-40 symbol-light-primary flex-shrink-0 mr-3">
                                <span class="symbol-label font-size-h6 font-weight-bold">{{ user.name }}</span>
                            </div>
                            <div>
                                <div class="font-size-lg">{{ user.name }}</div>
                                <div class="text-muted font-size-sm"><i
                                    class="fas fa-user-lock mr-2"></i>
<!--                                    {{ user.roles[0].name.toLowerCase().replace(/\b[a-z]/g, function(letter) {
                                                                                        return letter.toUpperCase();
                                                                                    })
                                    }}-->
                                </div>
                            </div>
                        </div>
                        <i class="fas fa-arrow-circle-right text-muted px-10"></i>
                        <div class="flex-grow-1">
                            <select class="form-control selectpicker" v-model="assignData.agency" id="agency" name="agency" required="required"
                                    data-live-search="true">
                                <option value="" disabled selected>{{ __('actions.please_select') }}...</option>
                                <option v-for="agency in agencies" :value="agency.id">{{ agency.name }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-group pt-10">
                        <div class="card card-custom bg-light-danger text-danger">
                            <div class="card-body text-danger font-size-h5 p-16">
                                <div class="d-flex align-items-center">
                                    <i class="fas fa-exclamation-triangle mr-5 font-size-h1"></i>
                                    <div v-html="__('agency.warnings.assign_user')">
                                    </div>
                                </div>

                                <div class="checkbox-list mt-10">
                                    <label class="checkbox checkbox-danger text-danger font-size-h6">
                                        <input type="checkbox" name="checkbox" required v-model="understand">
                                        <span></span>{{ __('agency.warnings.understand') }}
                                    </label>
                                </div>

                                <button class="btn btn-danger mt-10" @click="submit"><i class="fas fa-random"></i> {{ __('actions.assign') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-3">
                    <BackButton v-if="$page.props.previous_url" :to="__('actions.abort')" icon="fas fa-times" />
                </div>
            </form>
        </Card>

    </div>
</template>

<script>
import Card from "@components/Cards/Card.vue";
import Toolbar from "@components/Toolbar.vue";
import {Head} from "@inertiajs/inertia-vue";
import ToolbarLink from "@components/ToolbarLink.vue";
import {PermissionsMixin} from "@js/permissions";
import BackButton from '@components/BackButton.vue'

export default {
    components: {
        BackButton,
        ToolbarLink,
        Toolbar,
        Card,
        Head,
    },

    mixins: [PermissionsMixin],

    props: {
        user: Object,
        agencies: Array
    },

    data() {
        return {
            assignData: this.$inertia.form({
                agency: null,
            }),
            understand: false,
        }
    },

    methods: {
        submit() {
            if (!this.understand) {
                return false;
            }
            this.assignData.post(this.$route('user.assign-to-agency.post', {'user': this.user.id}), {
                preserveScroll: true,
                preserveState: true,
                onSuccess: () => {
                    this.cancel()
                },
            })
        },
    },
}
</script>
